import { cx } from 'class-variance-authority';

import Motion from '@/app/components/Motion';

import { PhotoGridColumn } from './PhotoGridColumn';
import type { PhotoGridProps } from './types';

export function PhotoGrid({ className, columns }: Readonly<PhotoGridProps>) {
  return (
    <Motion
      initial={{ opacity: 0 }}
      transition={{ duration: 1, type: 'tween', delay: 0.5 }}
      viewport={{ once: true }}
      whileInView={{ opacity: 1 }}
    >
      <div
        className={cx(
          'relative left-1/2 grid -translate-x-1/2 items-end gap-x-3 pb-16 md:gap-x-5 lg:pb-0',
          className,
        )}
        data-cy="pop_lifestyle_photo_grid"
      >
        {columns.map((column) => (
          <PhotoGridColumn key={column.id} {...column} />
        ))}
      </div>
    </Motion>
  );
}
